<style>
	@import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Service Management" title="Pending Payments" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list filter-sort">
								<div class="row align-items-end">
									<div class="col-md-6 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<select class="form-select" v-model="listing_length" @change="fetchPendingPayments()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									<div class="col-md-2 form-group mt-2 position-relative">
										<label class="control-label small mb-1">Dealer</label>
										<input
											type="text"
											class="form-control"
											placeholder="All Dealers"
											v-model="filterDealerSearch"
											@input="onFilterDealerSearchInput"
											@focus="showFilterDealerSuggestions = true"
											@blur="hideFilterDealerSuggestions"
											autocomplete="off"
										/>
										<ul
											v-if="showFilterDealerSuggestions && filteredFilterDealers.length"
											class="list-group position-absolute w-100"
											style="z-index: 20; max-height: 220px; overflow-y: auto;"
										>
											<li
												class="list-group-item list-group-item-action"
												@mousedown.prevent="clearFilterDealer"
											>
												All Dealers
											</li>
											<li
												v-for="dealer in filteredFilterDealers"
												:key="'fd-' + dealer.id"
												class="list-group-item list-group-item-action"
												@mousedown.prevent="selectFilterDealer(dealer)"
											>
												{{ dealer.first_name }}
											</li>
										</ul>
										<small v-if="selectedFilterDealer" class="text-muted d-block mt-1">
											Selected: {{ selectedFilterDealer.first_name }}
											<button type="button" class="btn btn-link btn-sm p-0 ms-1" @click="clearFilterDealer">Clear</button>
										</small>
									</div>
									<div class="col-md-2 form-group mt-2">
										<label class="control-label small mb-1">Service type</label>
										<select class="form-select" v-model="filter_service_type" @change="fetchPendingPayments()">
											<option value="">All service types</option>
											<option value="1">SIM Change</option>
											<option value="2">Repair</option>
											<option value="3">Replacement</option>
											<option value="4">No Data</option>
											<option value="5">Tracking Issue</option>
											<option value="6">Hardware Issue</option>
											<option value="7">Software Issue</option>
											<option value="8">Alert Fail</option>
											<option value="9">Other</option>
											<option value="10">Renewal Replacement</option>
										</select>
									</div>
									<div class="col-md-2 mt-2">
										<label class="control-label small mb-1">Search</label>
										<input type="text" class="form-control" placeholder="Search" v-model="keyword" @input="fetchPendingPayments()" />
									</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
                                            <th>Sl.No</th>  
                                            <th>IMEI</th>
											<th>Dealer</th>
											<th>Vehicle Details</th>
											<th>Service Type</th>
											<th>Date</th>
                                            <th>Amount</th>
                                            <th>Payment Status</th>
											<th>Updated By</th>
											<th>Options</th>
                                        </tr>
									</thead>
									<tbody v-if="Boolean(pendingPayments.length)">
										
										<tr  v-for="(payment, index) in pendingPayments" :key="payment.id" align="center">
                                            <td>{{ index + 1 }}</td>
											<td>
												<span v-if="payment.imei"><b>IMEI:-</b>{{ payment.imei }} <br> </span>
												<span v-if="payment.iccid"><b>ICCID:-</b>{{ payment.iccid }} <br> </span>
												<span v-if="payment.sim_provider"><b>SIM Provider:-</b>{{ payment.sim_provider || '-' }} <br> </span>
											</td>
											<td>{{ formatDealerName(payment) }}</td>
											<td>
												<span v-if="payment.vehicle_no"><b>Vehicle No:-</b>{{ payment.vehicle_no }} <br> </span>
												<span v-if="payment.customer_name"><b>Name:-</b>{{ payment.customer_name }} <br> </span>
												<span v-if="payment.mobile"><b>Contact:-</b>{{ payment.mobile }} <br> </span>
											</td>
											<td><b>{{ serviceTypeLabel(payment.service_type) }}</b></td>
											<td>{{ $filters.formatDate(payment.created_date) }}</td>
											<td>Total: {{ payment.total_amount }} <br> Cash: {{ payment.cash_in_hand }} <br> Online: {{ payment.cash_online }} <br> Credit: {{ payment.credit_amount }} <br> Balance: {{ payment.balance_amount }}</td>

                                            <td>
												<span class="badge rounded-pill bg-success" v-if="payment.payment_status == 1">Payment Received</span>
												<span class="badge rounded-pill bg-danger" v-if="payment.payment_status == 2">Payment Pending</span>
												<span class="badge rounded-pill bg-warning" v-if="payment.payment_status == 3">Partial Payment</span>
												<span class="badge rounded-pill bg-info" v-if="payment.payment_status == 4">Free Service</span>
												<span class="badge rounded-pill bg-secondary" v-if="payment.payment_status == 5">Credit</span>
											</td>
											<td>{{ payment.updated_user_name }}<br>
												{{ $filters.formatDateTime(payment.updated_at) }}
											</td>
                                            <td>
												<button class="btn btn-info btn-sm me-1" @click="openServiceLogs(payment)">Logs</button>
												<button class="btn btn-success btn-sm mt-1 me-1" @click="updatePayment(payment)">Update Payment</button>
												<button class="btn btn-warning btn-sm mt-1" @click="openUpdateServiceModal(payment)" v-if="$canUpdateRenewalData()">Update Service Data</button>
											</td>
                                        </tr>
                                    </tbody>
									<tbody v-else>
										<tr>
											<td colspan="12" align="center">No data available in the table</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<caption v-if="Boolean(pendingPayments.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>
							<nav aria-label="Page navigation" class="mt-2 float-end">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchPendingPayments(page.url)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav> 
							<!----pagination ends --->
							
						</div>
					</div>
				</div>
			</div>
		</div>

		<DynamicModal :title=modal_title>
			<template #body>
				<form @submit.prevent="" enctype="multipart/form-data">
					<div class="col-md-12 mb-3" v-if="modalPayment && getRecordPaidAmount() > 0">
						<div class="alert alert-light border">
							<strong>Already paid:</strong> ₹{{ getRecordPaidAmount().toFixed(2) }}
							<span v-if="record_cash_online > 0"> (Online: ₹{{ record_cash_online }})</span>
							<span v-if="record_cash_in_hand > 0"> (Cash: ₹{{ record_cash_in_hand }})</span>
							<span v-if="record_credit_amount > 0"> (Credit: ₹{{ record_credit_amount }})</span>
							<span> | <strong>Balance:</strong> ₹{{ getRecordBalance().toFixed(2) }}</span>
						</div>
					</div>

					<div class="col-md-12 form-group mt-2">
						<label class="control-label">Total Amount<span class="text-danger">*</span></label>
						<input class="form-control" type="number" step="0.01" min="0" placeholder="Enter total amount" v-model="cost"/>
					</div>

					<div class="col-md-12 form-group mt-2">
						<label class="control-label">Payment Status<span class="text-danger">*</span></label>
						<select class="form-select" v-model="payment_status" @change="onPaymentStatusChange">
							<option value="">--Select Payment Status--</option>
							<option value="1">Payment received now</option>
							<option value="2">No new payment</option>
						</select>
					</div>

					<div class="col-md-12 form-group mt-2" v-if="payment_status">
						<label class="control-label">Remarks</label>
						<textarea class="form-control" placeholder="Optional remarks" v-model="remarks"></textarea>
					</div>

					<div class="col-md-12 form-group mt-2" v-if="payment_status === '1'">
						<label class="control-label">Payment Date<span class="text-danger">*</span></label>
						<input class="form-control" type="date" v-model="payment_date" />
					</div>

					<div class="col-md-12 form-group mt-2" v-if="payment_status === '1'">
						<label class="control-label">Payment By<span class="text-danger">*</span></label>
						<select class="form-select" v-model="payment_by" @change="onPaymentByChange" :disabled="paymentByLocked">
							<option value="">--Select Payment By--</option>
							<option value="1">Dealer</option>
							<option value="2">Customer</option>
						</select>
					</div>

					<div class="col-md-12 form-group mt-2" v-if="payment_status === '1' && payment_by == '1'">
						<label class="control-label">Payment Dealer<span class="text-danger">*</span></label>
						<div v-if="paymentByLocked && selectedPaymentDealer" class="form-control bg-light">
							{{ selectedPaymentDealer.first_name }}
						</div>
						<div v-else class="position-relative">
							<input
								class="form-control"
								type="text"
								placeholder="Search dealer..."
								v-model="paymentDealerSearch"
								@input="searchPaymentDealer"
								@focus="showPaymentDealerSuggestions = true"
								@blur="hidePaymentDealerSuggestions"
								autocomplete="off"
							/>
							<ul
								v-if="showPaymentDealerSuggestions && filteredPaymentDealers.length"
								class="list-group position-absolute w-100"
								style="z-index: 1056; max-height: 200px; overflow-y: auto;"
							>
								<li
									v-for="dealer in filteredPaymentDealers"
									:key="'pd-' + (dealer.user_id || dealer.id)"
									class="list-group-item list-group-item-action"
									@mousedown.prevent="selectPaymentDealer(dealer)"
								>
									{{ dealer.first_name }}
								</li>
							</ul>
						</div>
						<div v-if="!paymentByLocked && selectedPaymentDealer" class="mt-2">
							<small class="text-success">
								<i class="icofont icofont-check-circled me-1"></i>
								Selected: <strong>{{ selectedPaymentDealer.first_name }}</strong>
							</small>
						</div>
					</div>

					<div class="col-md-12 form-group mt-2" v-if="payment_status === '1' && payment_by == '2'">
						<label class="control-label">Customer<span class="text-danger">*</span></label>
						<div v-if="paymentByLocked && selectedPaymentCustomer" class="form-control bg-light">
							{{ selectedPaymentCustomer.company_name }}
						</div>
						<div v-else class="position-relative">
							<input
								class="form-control"
								type="text"
								placeholder="Search by name or mobile..."
								v-model="paymentCustomerSearch"
								@input="searchPaymentCustomer"
								@focus="showPaymentCustomerSuggestions = true"
								@blur="hidePaymentCustomerSuggestions"
								autocomplete="off"
							/>
							<ul
								v-if="showPaymentCustomerSuggestions && filteredPaymentCustomers.length"
								class="list-group position-absolute w-100"
								style="z-index: 1056; max-height: 200px; overflow-y: auto;"
							>
								<li
									v-for="cust in filteredPaymentCustomers"
									:key="cust.id"
									class="list-group-item list-group-item-action"
									@mousedown.prevent="selectPaymentCustomer(cust)"
								>
									{{ cust.company_name }}
									<small v-if="cust.mobile" class="text-muted d-block">{{ cust.mobile }}</small>
								</li>
							</ul>
						</div>
						<div v-if="!paymentByLocked && selectedPaymentCustomer" class="mt-2">
							<small class="text-success">
								<i class="icofont icofont-check-circled me-1"></i>
								Selected: <strong>{{ selectedPaymentCustomer.company_name }}</strong>
							</small>
						</div>
					</div>

					<div class="col-md-12 form-group mt-2" v-if="payment_status === '1' && payment_user_id">
						<label class="control-label">Payment Type<span class="text-danger">*</span></label>
						<select class="form-select" v-model="payment_type" @change="onPaymentTypeChange">
							<option value="">--Select Payment Type--</option>
							<option value="1">Cash</option>
							<option value="2">Online</option>
							<option value="3">Both</option>
							<option value="4">Advance</option>
						</select>
					</div>

					<div class="col-md-12 form-group mt-2" v-if="showPendingPaymentCredit">
						<label class="control-label">Amount from credit<span class="text-danger">*</span></label>
						<input class="form-control" type="number" step="0.01" min="0" placeholder="Enter credit amount" v-model="amount_from_credit"/>
						<div v-if="userDueLoading" class="mt-2"><small class="text-success">Loading...</small></div>
						<div v-else-if="userDueCurrent" class="mt-2">
							<small class="text-success">Credit available: ₹{{ userDueCurrent.credit_available_amount || 0 }}</small>
						</div>
						<div v-else class="mt-2"><small class="text-muted">—</small></div>
						<div v-if="userDueError" class="text-danger small mt-1">{{ userDueError }}</div>
					</div>

					<div class="col-md-12 form-group mt-2" v-if="payment_status === '1' && payment_user_id && (payment_type == '2' || payment_type == '3')">
						<label class="control-label">Select Bank<span class="text-danger">*</span></label>
						<select class="form-select" v-model="bank_account_id">
							<option value="">--Select Bank--</option>
							<option v-for="bank in banks" :key="bank.id" :value="bank.id">
								{{ bank.bank_name }} ({{ bank.account_number }})
							</option>
						</select>
					</div>

					<div class="row" v-if="payment_status === '1' && payment_user_id && (payment_type == '2' || payment_type == '3')">
						<div class="col-md-6 form-group mt-2">
							<label class="control-label">Online Amount<span class="text-danger">*</span></label>
							<input class="form-control" type="number" step="0.01" min="0" placeholder="Enter online amount" v-model="online_amount"/>
						</div>
						<div class="col-md-6 form-group mt-2">
							<label class="control-label">Payment ID<span class="text-danger">*</span></label>
							<input class="form-control" type="text" placeholder="Enter payment ID" v-model="payment_id"/>
						</div>
					</div>

					<div class="col-md-12 form-group mt-2" v-if="payment_status === '1' && payment_user_id && (payment_type == '1' || payment_type == '3')">
						<label class="control-label">Cash Amount<span class="text-danger">*</span></label>
						<input class="form-control" type="number" step="0.01" min="0" placeholder="Enter cash amount" v-model="cash_amount"/>
					</div>

					<div class="col-md-12 mt-2" v-if="getPaymentBreakdown()">
						<div class="card border-light">
							<div class="card-body p-2">
								<div class="row text-center">
									<div class="col-md-2">
										<small class="text-muted">Total</small>
										<div class="fw-bold">₹{{ getPaymentBreakdown().total }}</div>
									</div>
									<div class="col-md-2" v-if="getPaymentBreakdown().recordPaid > 0">
										<small class="text-muted">Paid</small>
										<div class="fw-bold text-success">₹{{ getPaymentBreakdown().recordPaid }}</div>
									</div>
									<div class="col-md-2" v-if="payment_status === '1' && payment_type && (payment_type === '2' || payment_type === '3')">
										<small class="text-muted">Online</small>
										<div class="fw-bold">₹{{ getPaymentBreakdown().online }}</div>
									</div>
									<div class="col-md-2" v-if="payment_status === '1' && payment_type && (payment_type === '1' || payment_type === '3')">
										<small class="text-muted">Cash</small>
										<div class="fw-bold">₹{{ getPaymentBreakdown().cash }}</div>
									</div>
									<div class="col-md-2" v-if="payment_status === '1' && payment_type === '4'">
										<small class="text-muted">Credit</small>
										<div class="fw-bold">₹{{ getPaymentBreakdown().credit }}</div>
									</div>
									<div class="col-md-2">
										<small class="text-muted">Balance</small>
										<div class="fw-bold" :class="getPaymentBreakdown().balanceClass">₹{{ getPaymentBreakdown().balance }}</div>
									</div>
									<div class="col-md-2" v-if="payment_status === '1' && payment_type">
										<small class="text-muted">Status</small>
										<div class="fw-bold" :class="getPaymentBreakdown().statusClass">
											{{ getPaymentBreakdown().statusLabel }}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="col-md-12 form-group mt-3">
						<button type="submit" class="btn btn-primary me-3" @click="submitPaymentUpdate" :disabled="loading">{{ button_title }}</button>
						<button class="btn btn-light" type="button" @click="closeModal()">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>

		<div class="modal fade" id="serviceLogsModal" tabindex="-1" aria-labelledby="serviceLogsModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-lg modal-dialog-scrollable">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="serviceLogsModalLabel">
							Service Logs
							<small v-if="logsServiceId" class="text-muted ms-1">#{{ logsServiceId }}</small>
						</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<div v-if="logsLoading" class="text-center py-4">
							<div class="spinner-border spinner-border-sm text-primary" role="status"></div>
							<p class="mt-2 text-muted small mb-0">Loading logs…</p>
						</div>
						<div v-else-if="!serviceLogs.length" class="text-center text-muted py-4">No logs found</div>
						<div v-else class="table-responsive">
							<table class="table table-sm table-bordered align-middle mb-0">
								<thead class="table-light">
									<tr align="center">
										<th>Date</th>
										<th>Status</th>
										<th>Remarks</th>
										<th>Added by</th>
										<th>Updated</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="log in serviceLogs" :key="'slog-' + log.id" align="center">
										<td>{{ log.date ? $filters.formatDate(log.date) : "—" }}</td>
										<td>
											<span class="badge rounded-pill" :class="serviceLogStatusBadge(log.status)">
												{{ serviceLogStatusLabel(log.status) }}
											</span>
										</td>
										<td class="text-start">{{ log.remarks || "—" }}</td>
										<td class="text-start small">{{ log.added_user_name || "—" }}</td>
										<td class="small">
											{{ log.updated_user_name || "—" }}
											<br />
											<span class="text-muted">{{ log.updated_at ? $filters.formatDateTime(log.updated_at) : "" }}</span>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
					</div>
				</div>
			</div>
		</div>

		<UpdateServiceDataModal
			ref="updateServiceModal"
			modal-id="updateServiceDataModalPendingPayments"
			@updated="fetchPendingPayments(active_page_url || undefined)"
		/>

	</div>
</template>

<script>
import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
import UpdateServiceDataModal from '@/components/complaint/UpdateServiceDataModal.vue'

export default {
	name: "Pending Payments",
	components: {
		DynamicModal,
		UpdateServiceDataModal,
	},
	setup(){
		let dynamicmodal;
		let serviceLogsModal;

		onMounted(() => {
			dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
			serviceLogsModal = new Modal(document.getElementById('serviceLogsModal'));
		})

		const showModal = () => {
			dynamicmodal.show();
		}

		const hideModal = () => {
			dynamicmodal.hide();
		}

		const showServiceLogsModal = () => {
			if (!serviceLogsModal) {
				serviceLogsModal = new Modal(document.getElementById('serviceLogsModal'));
			}
			serviceLogsModal.show();
		}

		const hideServiceLogsModal = () => {
			if (!serviceLogsModal) {
				serviceLogsModal = new Modal(document.getElementById('serviceLogsModal'));
			}
			serviceLogsModal.hide();
		}

		return {
			showModal, hideModal, showServiceLogsModal, hideServiceLogsModal
		}
	},
	
	data() {
		return {
			modal_title: "Update Payment",
			button_title: "Update Payment",

			keyword: "",
			showsearch: false,
			listing_length: 10,
			token: "",
			errors: {},

			// List filters
			filter_dealer_id: "", // dealers.user_id passed as dealer_id
			filterDealerSearch: "",
			showFilterDealerSuggestions: false,
			selectedFilterDealer: null,
			filter_service_type: "",

			// Payment form data
			cost: "",
			payment_status: "",
			payment_date: "",
			payment_type: "",
			online_amount: "",
			cash_amount: "",
			payment_id: "",
			remarks: "",
			payment_by: "",
			payment_user_id: "",
			bank_account_id: "",
			paymentByLocked: false,
			modalPayment: null,
			record_cash_online: 0,
			record_cash_in_hand: 0,
			record_credit_amount: 0,
			paymentDealerSearch: "",
			showPaymentDealerSuggestions: false,
			selectedPaymentDealer: null,
			dealers: [],
			companies: [],
			banks: [],
			paymentCustomerSearch: "",
			showPaymentCustomerSuggestions: false,
			selectedPaymentCustomer: null,
			amount_from_credit: "",
			userDue: null,
			userDueLoading: false,
			userDueError: "",
			
			// Dynamic data properties
			pendingPayments: [],
			all_pending_payments: [], // Store all pending payments for filtering
			search_term: "",
			loading: false,
			selected_payment_id: null,

			// Service logs modal
			logsServiceId: null,
			serviceLogs: [],
			logsLoading: false,
		};
	},
	computed: {
		resultsCount() {
			return this.pendingPayments.length;
		},
		filteredFilterDealers() {
			if (!this.filterDealerSearch || !this.filterDealerSearch.trim()) return this.dealers;
			const q = this.filterDealerSearch.toLowerCase().trim();
			return this.dealers.filter((d) => (d.first_name || "").toLowerCase().includes(q));
		},
		filteredPaymentDealers() {
			if (!this.paymentDealerSearch || !this.paymentDealerSearch.trim()) return this.dealers;
			const q = this.paymentDealerSearch.toLowerCase();
			return this.dealers.filter((d) => (d.first_name || "").toLowerCase().includes(q));
		},
		filteredPaymentCustomers() {
			if (!this.paymentCustomerSearch || !this.paymentCustomerSearch.trim()) return this.companies;
			const q = this.paymentCustomerSearch.toLowerCase().trim();
			return this.companies.filter((c) => {
				const name = (c.company_name || "").toLowerCase();
				const mobile = String(c.mobile || "").toLowerCase();
				return name.includes(q) || mobile.includes(q);
			});
		},
		showPendingPaymentCredit() {
			return this.payment_status === "1" && this.payment_type === "4" && !!this.payment_user_id;
		},
		userDueCurrent() {
			const rows = this.userDue;
			if (Array.isArray(rows) && rows.length) return rows[0];
			return rows || null;
		},
	},
	created() {
		this.fetchPendingPayments();
		this.fetchDealers();
		this.fetchCompanies();
		this.fetchBankAccounts();
	},
	methods: {
			openUpdateServiceModal(payment) {
				this.$refs.updateServiceModal?.open(payment);
			},

			serviceTypeLabel(type) {
				const map = {
					1: "SIM Change",
					2: "Repair",
					3: "Replacement",
					4: "No Data",
					5: "Tracking Issue",
					6: "Hardware Issue",
					7: "Software Issue",
					8: "Alert Fail",
					9: "Other",
					10: "Renewal Replacement",
				};
				return map[Number(type)] || "N/A";
			},

			serviceLogStatusLabel(status) {
				const map = {
					1: "Pending",
					2: "Ongoing",
					3: "Completed",
					4: "To Vendor",
					5: "Component Replacement",
					6: "SIM Change",
					7: "Device Replacement",
					8: "Payment",
					9: "Revoke",
					10: "Update",
				};
				return map[Number(status)] || `Status ${status ?? "—"}`;
			},

			serviceLogStatusBadge(status) {
				const map = {
					1: "bg-warning text-dark",
					2: "bg-primary",
					3: "bg-success",
					4: "bg-info text-dark",
					5: "bg-secondary",
					6: "bg-dark",
					7: "bg-danger",
					8: "bg-success",
					9: "bg-danger",
					10: "bg-warning text-dark",
				};
				return map[Number(status)] || "bg-secondary";
			},

			openServiceLogs(payment) {
				const serviceId = payment?.id;
				if (!serviceId) {
					this.$swal("Error", "Service id not found", "error");
					return;
				}
				this.logsServiceId = serviceId;
				this.serviceLogs = [];
				this.logsLoading = true;
				this.showServiceLogsModal();
				this.getToken();
				this.$axios
					.get("/staffs/serviceLogs", {
						headers: { Authorization: "Bearer " + this.token },
						params: { service_id: serviceId },
					})
					.then((res) => {
						const data = res.data?.data || {};
						this.serviceLogs = Array.isArray(data.serviceLogs) ? data.serviceLogs : [];
					})
					.catch((err) => {
						this.serviceLogs = [];
						this.$swal("Error", this.$getApiErrorMessage(err, "Failed to load service logs"), "error");
					})
					.finally(() => {
						this.logsLoading = false;
					});
			},

			formatDealerName(payment) {
				const dealerName = payment?.dealer_first_name;
				if (dealerName != null && String(dealerName).trim() !== '') {
					return dealerName;
				}
				const parts = [payment?.dealer_first_name, payment?.dealer_last_name].filter(Boolean);
				return parts.join(' ') || '-';
			},

			// formatDealerName(payment) {
			// 	const dealerName = payment?.dealer_name;
			// 	if (dealerName != null && String(dealerName).trim() !== '') {
			// 		return dealerName;
			// 	}
			// 	const parts = [payment?.dealer_first_name, payment?.dealer_last_name].filter(Boolean);
			// 	return parts.join(' ') || '-';
			// },

			getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},

			buildPendingPaymentsUrl(page_url = null) {
				let page = null;
				if (page_url) {
					try {
						const u = new URL(page_url, window.location.origin);
						page = u.searchParams.get("page");
					} catch (e) {
						const m = String(page_url).match(/[?&]page=([^&]+)/);
						page = m ? m[1] : null;
					}
				}
				const params = new URLSearchParams();
				params.append("limit", this.listing_length);
				params.append("keyword", this.keyword || "");
				if (this.filter_dealer_id) {
					params.append("dealer_id", this.filter_dealer_id);
				}
				if (this.filter_service_type !== "" && this.filter_service_type != null) {
					params.append("service_type", this.filter_service_type);
				}
				if (page) {
					params.append("page", page);
				}
				return "/staffs/pendingPayments?" + params.toString();
			},

			fetchPendingPayments(page_url = null) {
				this.getToken();
				const url = this.buildPendingPaymentsUrl(page_url);
				this.active_page_url = url;
				this.$axios
					.get(url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						this.pendingPayments = responseData.pendingPayments.data;
						this.pagination = responseData.pendingPayments.links;
						this.from = responseData.pendingPayments.from;
						this.to = responseData.pendingPayments.to;
						this.total = responseData.pendingPayments.total;
					})
					.catch((err) => console.log(err));
			},

			onFilterDealerSearchInput() {
				this.showFilterDealerSuggestions = true;
				if (this.selectedFilterDealer) {
					const selectedName = (this.selectedFilterDealer.first_name || "").toLowerCase();
					if ((this.filterDealerSearch || "").toLowerCase().trim() !== selectedName) {
						this.selectedFilterDealer = null;
						this.filter_dealer_id = "";
					}
				}
			},

			hideFilterDealerSuggestions() {
				setTimeout(() => {
					this.showFilterDealerSuggestions = false;
				}, 200);
			},

			selectFilterDealer(dealer) {
				this.selectedFilterDealer = dealer;
				this.filterDealerSearch = dealer.first_name || "";
				this.filter_dealer_id = this.getSelectedUserId(dealer);
				this.showFilterDealerSuggestions = false;
				this.fetchPendingPayments();
			},

			clearFilterDealer() {
				this.selectedFilterDealer = null;
				this.filterDealerSearch = "";
				this.filter_dealer_id = "";
				this.showFilterDealerSuggestions = false;
				this.fetchPendingPayments();
			},

			fetchDealers() {
				this.getToken();
				this.$axios
					.get("/staffs/dealers", { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						this.dealers = res.data?.data || [];
					})
					.catch(() => {
						this.dealers = [];
					});
			},

			fetchCompanies() {
				this.getToken();
				this.$axios
					.get("/staffs/companies", { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						const data = res.data.data || res.data;
						this.companies = Array.isArray(data) ? data : data?.data || [];
					})
					.catch(() => {
						this.companies = [];
					});
			},

			fetchBankAccounts() {
				this.getToken();
				this.$axios
					.get("/staffs/bankAccounts", { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						const data = res.data.data || res.data;
						this.banks = Array.isArray(data) ? data : data?.data || [];
					})
					.catch(() => {
						this.banks = [];
					});
			},

			getSelectedUserId(entity) {
				return entity && entity.user_id ? String(entity.user_id) : "";
			},

			getPaymentByType(payment) {
				const val = payment?.payment_by ?? payment?.payment_user_type;
				return val != null && val !== "" ? String(val) : "";
			},

			getPaymentById(payment) {
				const val = payment?.payment_by_id ?? payment?.payment_user_id;
				return val != null && val !== "" ? String(val) : "";
			},

			getRecordPaidAmount() {
				return (
					(parseFloat(this.record_cash_online) || 0) +
					(parseFloat(this.record_cash_in_hand) || 0) +
					(parseFloat(this.record_credit_amount) || 0)
				);
			},

			getRecordBalance() {
				const total = parseFloat(this.cost) || 0;
				return total - this.getRecordPaidAmount();
			},

			todayIsoDate() {
				const d = new Date();
				const y = d.getFullYear();
				const m = String(d.getMonth() + 1).padStart(2, "0");
				const day = String(d.getDate()).padStart(2, "0");
				return `${y}-${m}-${day}`;
			},

			resetPaymentForm() {
				this.cost = "";
				this.payment_status = "";
				this.payment_date = "";
				this.payment_type = "";
				this.online_amount = "";
				this.cash_amount = "";
				this.payment_id = "";
				this.remarks = "";
				this.payment_by = "";
				this.payment_user_id = "";
				this.bank_account_id = "";
				this.paymentByLocked = false;
				this.modalPayment = null;
				this.record_cash_online = 0;
				this.record_cash_in_hand = 0;
				this.record_credit_amount = 0;
				this.selectedPaymentDealer = null;
				this.paymentDealerSearch = "";
				this.selectedPaymentCustomer = null;
				this.paymentCustomerSearch = "";
				this.amount_from_credit = "";
				this.userDue = null;
				this.userDueLoading = false;
				this.userDueError = "";
			},

			initPaymentFromRecord(payment) {
				this.modalPayment = payment;
				this.record_cash_online = parseFloat(payment.cash_online) || 0;
				this.record_cash_in_hand = parseFloat(payment.cash_in_hand) || 0;
				this.record_credit_amount = parseFloat(payment.credit_amount) || 0;

				const paymentBy = this.getPaymentByType(payment);
				const paymentById = this.getPaymentById(payment);

				if (paymentBy && paymentById) {
					this.paymentByLocked = true;
					this.payment_by = paymentBy;
					this.payment_user_id = paymentById;

					if (paymentBy === "1") {
						// airo_work_services.dealer_id stores dealers.user_id (not dealers.id)
						const dealerUserId = payment.dealer_id ?? paymentById;
						const dealer = dealerUserId != null
							? this.dealers.find((d) => String(d.user_id) === String(dealerUserId))
							: null;
						if (dealer) {
							this.selectedPaymentDealer = dealer;
							this.paymentDealerSearch = dealer.first_name || "";
							this.payment_user_id = this.getSelectedUserId(dealer);
						} else {
							this.selectedPaymentDealer = {
								id: null,
								first_name: this.formatDealerName(payment),
								user_id: dealerUserId,
							};
							this.paymentDealerSearch = this.formatDealerName(payment);
							this.payment_user_id = String(dealerUserId);
						}
					} else if (paymentBy === "2") {
						const customerId = payment.customer_id ?? payment.company_id;
						const customer = customerId != null
							? this.companies.find((c) => c.id == customerId || String(c.id) === String(customerId))
							: null;
						if (customer) {
							this.selectedPaymentCustomer = customer;
							this.paymentCustomerSearch = customer.company_name || "";
						} else {
							this.selectedPaymentCustomer = {
								id: customerId,
								company_name: payment.company_name || payment.customer_name || "Customer",
								user_id: paymentById,
							};
							this.paymentCustomerSearch = payment.company_name || payment.customer_name || "Customer";
						}
					}
				} else {
					this.paymentByLocked = false;
					this.payment_by = "1";
					this.initDefaultDealerFromPayment(payment);
				}
			},

			initDefaultDealerFromPayment(payment) {
				this.selectedPaymentCustomer = null;
				this.paymentCustomerSearch = "";
				this.selectedPaymentDealer = null;
				this.paymentDealerSearch = "";
				this.payment_user_id = "";

				// airo_work_services.dealer_id stores dealers.user_id (not dealers.id)
				const dealerUserId =
					payment?.dealer_id != null
						? payment.dealer_id
						: payment?.dealer_user_id != null
							? payment.dealer_user_id
							: null;
				if (dealerUserId == null || dealerUserId === "") return;

				const dealer = this.dealers.find((d) => String(d.user_id) === String(dealerUserId));
				if (dealer) {
					this.selectedPaymentDealer = dealer;
					this.paymentDealerSearch = dealer.first_name || "";
					this.payment_user_id = this.getSelectedUserId(dealer);
				} else {
					this.paymentDealerSearch = this.formatDealerName(payment);
					this.selectedPaymentDealer = {
						id: null,
						first_name: this.formatDealerName(payment),
						user_id: dealerUserId,
					};
					this.payment_user_id = String(dealerUserId);
				}
			},

			onPaymentStatusChange() {
				if (this.payment_status === "1") {
					if (!this.payment_date) {
						this.payment_date = this.todayIsoDate();
					}
				} else {
					this.payment_date = "";
					this.payment_type = "";
					this.bank_account_id = "";
					this.online_amount = "";
					this.cash_amount = "";
					this.payment_id = "";
					this.amount_from_credit = "";
				}
			},

			onPaymentByChange() {
				if (this.paymentByLocked) return;

				this.payment_user_id = "";
				this.payment_type = "";
				this.bank_account_id = "";
				this.online_amount = "";
				this.cash_amount = "";
				this.payment_id = "";
				this.amount_from_credit = "";
				this.selectedPaymentDealer = null;
				this.selectedPaymentCustomer = null;
				this.paymentDealerSearch = "";
				this.paymentCustomerSearch = "";

				if (this.payment_by === "1" && this.modalPayment) {
					this.initDefaultDealerFromPayment(this.modalPayment);
				}
			},

			onPaymentTypeChange() {
				if (this.payment_type === "2") {
					this.cash_amount = "";
				} else if (this.payment_type === "1") {
					this.online_amount = "";
					this.payment_id = "";
				} else if (this.payment_type === "4") {
					this.online_amount = "";
					this.cash_amount = "";
					this.payment_id = "";
					this.amount_from_credit = this.getRecordBalance() > 0 ? String(this.getRecordBalance().toFixed(2)) : this.cost || "";
				}
				if (!(this.payment_type === "2" || this.payment_type === "3")) {
					this.bank_account_id = "";
				}
				this.maybeFetchPendingPaymentCredit();
			},

			searchPaymentDealer() {
				this.showPaymentDealerSuggestions = true;
			},
			hidePaymentDealerSuggestions() {
				setTimeout(() => {
					this.showPaymentDealerSuggestions = false;
				}, 200);
			},
			selectPaymentDealer(dealer) {
				this.selectedPaymentDealer = dealer;
				this.paymentDealerSearch = dealer.first_name;
				this.showPaymentDealerSuggestions = false;
				this.payment_user_id = this.getSelectedUserId(dealer);
				this.maybeFetchPendingPaymentCredit();
			},

			searchPaymentCustomer() {
				this.showPaymentCustomerSuggestions = true;
			},
			hidePaymentCustomerSuggestions() {
				setTimeout(() => {
					this.showPaymentCustomerSuggestions = false;
				}, 200);
			},
			selectPaymentCustomer(cust) {
				this.selectedPaymentCustomer = cust;
				this.paymentCustomerSearch = cust.company_name;
				this.showPaymentCustomerSuggestions = false;
				this.payment_user_id = this.getSelectedUserId(cust);
				this.maybeFetchPendingPaymentCredit();
			},

			async maybeFetchPendingPaymentCredit() {
				if (!this.showPendingPaymentCredit) {
					this.userDue = null;
					this.userDueLoading = false;
					this.userDueError = "";
					if (this.payment_type !== "4") {
						this.amount_from_credit = "";
					}
					return;
				}
				await this.fetchPendingPaymentUserDue();
			},

			async fetchPendingPaymentUserDue() {
				try {
					this.getToken();
					this.userDueLoading = true;
					this.userDueError = "";
					const response = await this.$axios.get("/staffs/getUserDue", {
						params: { user_id: this.payment_user_id },
						headers: { Authorization: "Bearer " + this.token },
					});
					const ok = response.data?.status === true || response.data?.status === "true";
					if (!ok) {
						this.userDue = null;
						this.userDueError = response.data?.message || "Failed to fetch credit balance";
						return;
					}
					this.userDue = response.data?.data?.userDue || null;
				} catch (e) {
					this.userDue = null;
					this.userDueError = e?.response?.data?.message || "Failed to fetch credit balance";
				} finally {
					this.userDueLoading = false;
				}
			},

		openModal() {
			this.showModal();
		},

		getPaymentBreakdown() {
			const total = parseFloat(this.cost) || 0;
			if (!total && !this.getRecordPaidAmount()) return null;

			const recordPaid = this.getRecordPaidAmount();
			const online = parseFloat(this.online_amount) || 0;
			const cash = parseFloat(this.cash_amount) || 0;
				const credit = parseFloat(this.amount_from_credit) || 0;

			let newPaid = 0;
			if (this.payment_status === "1" && this.payment_type) {
				if (this.payment_type === "2") newPaid = online;
				else if (this.payment_type === "1") newPaid = cash;
				else if (this.payment_type === "3") newPaid = online + cash;
					else if (this.payment_type === "4") newPaid = credit;
			}

			const totalPaid = recordPaid + newPaid;
			const balance = total - totalPaid;
			const eps = 0.01;

			let statusLabel = "Partial";
			let statusClass = "text-warning";
			if (Math.abs(balance) < eps) {
				statusLabel = "Full";
				statusClass = "text-success";
			} else if (balance < -eps) {
				statusLabel = "Advance";
				statusClass = "text-info";
			}

			let balanceClass = balance > eps ? "text-danger" : "text-success";
			if (Math.abs(balance) < eps) balanceClass = "text-success";

			return {
				total: total.toFixed(2),
				recordPaid: recordPaid.toFixed(2),
				online: online.toFixed(2),
				cash: cash.toFixed(2),
					credit: credit.toFixed(2),
				balance: Math.abs(balance).toFixed(2),
				balanceClass,
				statusLabel,
				statusClass,
			};
		},

		closeModal() {
			this.hideModal();
			this.resetPaymentForm();
		},

		updatePayment(payment) {
			this.errors = {};
			this.resetPaymentForm();
			this.cost = payment.total_amount || "";
			this.modal_title = "Update Payment";
			this.button_title = "Update Payment";
			this.selected_payment_id = payment.id;
			this.initPaymentFromRecord(payment);
			this.showModal();
		},

		

		// Handle form submission for updating payment
		submitPaymentUpdate() {
			if (!this.selected_payment_id) {
				this.$swal('Error', 'No payment selected', 'error');
				return;
			}

			if (this.cost === "" || this.cost === null) {
				this.$swal('Error', 'Please enter the total amount', 'error');
				return;
			}

			if (!this.payment_status) {
				this.$swal('Error', 'Please select payment status', 'error');
				return;
			}

			if (this.payment_status === '1') {
				if (!this.payment_date) {
					this.$swal('Error', 'Please select payment date', 'error');
					return;
				}
				if (!this.payment_by) {
					this.$swal('Error', 'Please select payment by', 'error');
					return;
				}
				if (!this.payment_user_id) {
					this.$swal('Error', 'Please select dealer or customer for payment', 'error');
					return;
				}
				if (!this.payment_type) {
					this.$swal('Error', 'Please select payment type', 'error');
					return;
				}

				if (this.payment_type === '4') {
					const ca = parseFloat(this.amount_from_credit);
					if (!this.amount_from_credit || isNaN(ca) || ca <= 0) {
						this.$swal('Error', 'Please enter amount from credit', 'error');
						return;
					}
					const avail = parseFloat(this.userDueCurrent?.credit_available_amount);
					if (!isNaN(avail) && ca > avail) {
						this.$swal('Error', 'Amount from credit cannot exceed available credit', 'error');
						return;
					}
					const cap = parseFloat(this.getRecordBalance());
					if (!isNaN(cap) && ca > cap) {
						this.$swal('Error', 'Amount from credit cannot exceed balance amount', 'error');
						return;
					}
				}

				if (this.payment_type === '2' || this.payment_type === '3') {
					if (!this.bank_account_id) {
						this.$swal('Error', 'Please select bank account', 'error');
						return;
					}
					if (this.online_amount === "" || !this.payment_id) {
						this.$swal('Error', 'Please enter online amount and payment ID', 'error');
						return;
					}
				}
				if (this.payment_type === '1' || this.payment_type === '3') {
					if (this.cash_amount === "") {
						this.$swal('Error', 'Please enter cash amount', 'error');
						return;
					}
				}
			}

			this.loading = true;

			const payload = {
				service_id: this.selected_payment_id,
				total_amount: this.cost,
				payment_status: this.payment_status,
				remarks: this.remarks || '',
			};

			if (this.payment_status === '1') {
				payload.payment_date = this.payment_date;
				payload.payment_type = this.payment_type;
				payload.payment_user_type = this.payment_by;
				payload.payment_user_id = this.payment_user_id;
				payload.cash_online = '';
				payload.cash_in_hand = '';
				payload.payment_id = '';
				payload.bank_account_id = '';
				payload.amount_from_credit = 0;
				payload.deduct_from_credit = 2;

				if (this.payment_type === '2' || this.payment_type === '3') {
					payload.cash_online = this.online_amount;
					payload.payment_id = this.payment_id;
					payload.bank_account_id = this.bank_account_id;
				}
				if (this.payment_type === '1' || this.payment_type === '3') {
					payload.cash_in_hand = this.cash_amount;
				}
				if (this.payment_type === '4') {
					payload.amount_from_credit = parseFloat(this.amount_from_credit) || 0;
					payload.deduct_from_credit = 1;
				}
			}

			this.getToken();

			this.$axios.post('/staffs/updatePayment', payload, {
				headers: { Authorization: "Bearer " + this.token }
			})
			.then(res => {
				if (res.data.status === true || res.data.status === 'true') {
					this.$swal('Success', this.$extractApiMessage(res.data.message) || 'Payment updated successfully', 'success');
					this.closeModal();
					this.fetchPendingPayments(this.active_page_url || null);
				} else {
					this.$swal('Error', this.$getApiErrorMessage(res.data, 'Failed to update payment'), 'error');
				}
			})
			.catch(err => {
				console.error(err);
				this.$swal('Error', this.$getApiErrorMessage(err, 'Something went wrong'), 'error');
			})
			.finally(() => {
				this.loading = false;
			});
		},

		
	},
};
</script>
